/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes, arrayOf, number, shape, string } from 'prop-types';
import { customAcronym, customColor, getSite } from '../../constants';

export default function HeaderPoliticians({
  parties,
  totalSeat,
  placeName,
  selectedId,
  onChange
}) {
  const selectedItem = parties?.find(item => item.id === selectedId);

  const totalSeatsBySelected = selectedItem?.inFavor?.reduce(
    (acc, item) => acc + item.seats,
    0
  );
  const isPresidency = totalSeatsBySelected > parseInt(totalSeat / 2, 0) + 1;
  const canBePresidency =
    totalSeatsBySelected > parseInt(totalSeat / 2, 0) ? 'SI' : 'NO';

  return (
    <header className="PactosSiNo-header">
      <h2 className="PactosSiNo-title">
        ¿Podrá{' '}
        <strong>
          {/* {getParty(selectedsId)?.person.name || partyDefault?.person.name} */}
          {selectedItem?.person.name}
        </strong>{' '}
        obtener la presidencia de {placeName}?
      </h2>
      <p className="PactosSiNo-txt">
        {/* {getParty(selectedsId)?.person.name || partyDefault?.person.name}{' '} */}
        <strong>{canBePresidency}</strong> lograría la presidencia en la primera
        votación
        {!isPresidency && (
          <>
            , pero
            <strong> SÍ</strong> en la segunda si consigue más síes que noes.
          </>
        )}
      </p>
      <div className="PactosSiNo-btns">
        {parties?.map((item, index) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div className="PactosSiNo-wrapBtn" key={index}>
            <button
              className={
                selectedId === item.id
                  ? 'PactosSiNo-btn PactosSiNo-btn--active'
                  : 'PactosSiNo-btn'
              }
              type="button"
              onClick={() => {
                onChange(item.id);
              }}
            >
              <span
                className="PactosSiNo-wrap-img"
                style={
                  selectedId === item.id
                    ? {
                        backgroundColor: `${customColor(item.data, getSite())}`
                      }
                    : null
                }
              >
                <img
                  className="PactosSiNo-img"
                  src={item.person?.photo}
                  width={85}
                  height={85}
                  alt="Nombre del polític@"
                />
              </span>
              <span
                className="PactosSiNo-borde"
                style={
                  selectedId === item.id
                    ? {
                        backgroundColor: `${customColor(
                          item.data,
                          getSite()
                        )}65`
                      }
                    : null
                }
              />
              <span className="PactosSiNo-nombre">
                <strong>{`${customAcronym(item.data, getSite())}`}</strong>{' '}
                {item.person?.name}
              </span>
            </button>
          </div>
        ))}
      </div>
    </header>
  );
}

HeaderPoliticians.propTypes = {};

HeaderPoliticians.defaultProps = {
  selectedsId: [],
  setSelectedsId: () => {},
  setSelectedsNoId: () => {},
  totalSeat: undefined
};
